/* (c) Dalineage, s.r.o. 2020-2024, all rights reserved */
package com.dalineage.client

import org.scalajs.dom
import org.scalajs.dom.{document, html, MouseEvent}
import scala.scalajs.js

import com.dalineage.common


object MainApp {

  def main(args: Array[String]): Unit = {
    val container = document.getElementById("container").asInstanceOf[html.Div]

    val params = DomOps.parseQueryString()

    DomOps.sendRequest(
    dom.HttpMethod.GET, "web/current_user", { user =>
      js.Dynamic.global.user = user
      Workspace.init(container, params)
    },
    noCache = true)
  }
}
